import React from "react";
import { Container } from "./Container";
import { Row } from "react-bootstrap";
export var GridPage = function (_a) {
    var children = _a.children, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? "tiled" : _c;
    return (React.createElement("div", { className: "grid grid--".concat(type) },
        React.createElement(Container, { fluid: fullWidth }, children)));
};
export var GridRow = function (_a) {
    var children = _a.children;
    return (React.createElement(Container, { className: "grid-container" },
        React.createElement(Row, { className: "grid-row" }, children)));
};
